module.exports = __webpack_public_path__ + "akne_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_2_after.jpg
// module id = 917
// module chunks = 0